import React, { useEffect, useState, useRef, useContext } from 'react';
import { Link, useNavigate, useParams } from "react-router-dom";
import images from '../../../../services/images';
import ContentHeader from '../../../parts/ContentHeader';
import Layout from '../../../parts/Layout';
import helpers from '../../../../services/helpers';
import { httpRequest, httpAuthHeaders } from '../../../../services/httpService';
import Loader from '../../../parts/Loader';
import initTreeView from '../../../../services/initTreeView';
import ContactListModal from '../../../modals/ContactListModal';
import RenderErrors from '../../../elements/RenderErrors';
import VehiclesSearchModal from '../vehicles/VehiclesSearchModal';
import SchedulesForm from './SchedulesForm';
import { getApiData, postApiData } from '../../../../services/apiService';
import ProfileContext from '../../../../services/profileContext';
import QRScannerModal from '../../../parts/QRScannerModal';
import BoardingPreview from '../boarding/BoardingPreview';
import Swal from 'sweetalert2';
import { InputMask } from 'primereact/inputmask';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { InputNumber } from 'primereact/inputnumber';
import { RadioButton } from 'primereact/radiobutton';
import { Calendar } from 'primereact/calendar';
import { Steps } from 'primereact/steps';
import { InputSwitch } from 'primereact/inputswitch';
import { AutoComplete } from 'primereact/autocomplete';
import { Menu } from 'primereact/menu';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Panel } from 'primereact/panel';
import { 
    FaMapMarkerAlt, 
    FaTruck, 
    FaExchangeAlt,
    FaSearch, 
    FaCalendarAlt, 
    FaBus, 
    FaCreditCard, 
    FaCheckCircle, 
    FaEdit,
    FaChevronLeft, 
    FaChevronRight,
    FaShip, 
    FaCheck, 
    FaReceipt, 
    FaPrint, 
    FaAngleDown,
    FaEllipsisV,
    FaAnchor, 
    FaTimesCircle 
} from "react-icons/fa";
import { FaFileCircleCheck, FaListCheck  } from "react-icons/fa6";
import { CiReceipt } from "react-icons/ci";
import { BsThreeDotsVertical } from "react-icons/bs";
import { MdOutlineQrCodeScanner } from "react-icons/md";
 
export default function ScheduleView ({viewer = 'admin', menu = 'manage-schedules', page_title = "Voyage Schedule"}){
    const {
        account
    } = useContext(ProfileContext);
    const { schedule_id } = useParams();
    const navigate = useNavigate();
    const toast = useRef(null);
    const menuRight = useRef(null);
    const menuRef = useRef(null);
    const today = new Date();
    const [loading, setLoading] = useState(0);
    const [errors, setErrors] = useState([]);
    const [search_key, setSearchKey] = useState('');
    const [scheduleDetails, setScheduleDetails] = useState([]);
    const [manifestData, setManifestData] = useState([]);
    const [alignment, setAlignment] = useState('right'); // Default desktop to right
    const [data_table, setDataTable] = useState([]);
    const [datatable_state, setDataTableState] = useState({
        first: 0,
        rows: 10,
        page: 0,
        sortField: null,
        sortOrder: null
    });
    const [selected_items, setSelectedItems] = useState([]);
    const [selected_all, setSelectAll] = useState(false);
    const [selectedRowData, setSelectedRowData] = useState(null);
    const [show_schedule, setShowSchedule] = useState(0);
    const [show_scanner, setShowScanner] = useState(0);
    const [show_preview, setShowPreview] = useState(0);
    const [booking_item_id, setBookingItemID] = useState('');

    function checkStatus(){
        if(!helpers.checkPermissions(['superAdmin', 'shipOnBoarding'], account?.permissions)){
            return true
        }

        if(selectedRowData?.is_onboarded || scheduleDetails?.status_id == 5){
            return true
        }

        return false
    }

    const menuItems = [
        { 
        label: 'Board Vehicle', 
        icon: 'pi pi-eye',
        disabled:checkStatus(),
        command: () => {
            // e.g., router.push(`/bookings/${selectedRowData.id}`)
            Swal.fire({
                title: 'Vehicle Onboarding',
                text: 'Are you sure you want to onboard this vehicle?',
                showCancelButton: true,
                showConfirmButton: true,
                closeOnCancel: true,
                //showDenyButton: true,
                denyButtonText: 'Yes'
            })
            .then((result) => {
                if (result.isConfirmed) {
                    proceedOnboard(selectedRowData.id, schedule_id)
                }
            })
        }
        },
    ];

    const action_items = [
            {
                label: 'Print Manifest',
                icon: <FaPrint className='mr-2 text-dark'/>,
                //url: `/ship-booking/schedules/${schedule_id}/manifest`
                command: () => {
                    //router.push(`/ship-booking/schedules/${schedule_id}/manifest`);
                    window.open(`/ship-booking/schedules/${schedule_id}/manifest-print`, "_blank", "noopener,noreferrer");
                }
            },
            {
                label: 'Update Schedule',
                icon: <FaEdit className='mr-2 text-dark'/>,
                //url: `/ship-booking/schedules/${schedule_id}/manifest`
                command: () => {
                     setShowSchedule(true)
                    //router.push(`/ship-booking/schedules/${schedule_id}/manifest`);
                    //window.open(`/ship-booking/schedules/${schedule_id}/manifest-print`, "_blank", "noopener,noreferrer");
                },
                disabled: !helpers.checkPermissions(['superAdmin', 'voyageScheduleEdit'], account?.permissions),
            },
            {
                label: 'Ship Sail',
                icon: <FaShip className='mr-2 text-dark'/>,
                command: () => {
                    handleStatus(3)//Sail
                },
                visible: scheduleDetails.status_id == 2 ? true : false,
                disabled: !helpers.checkPermissions(['superAdmin', 'voyageScheduleEdit'], account?.permissions),
            },
            {
                label: 'Ship Arrived',
                icon: <FaAnchor className='mr-2 text-dark'/>,
                command: () => {
                    handleStatus(4)//Arrived
                },
                visible: scheduleDetails.status_id == 3 ? true : false,
                disabled: !helpers.checkPermissions(['superAdmin', 'voyageScheduleEdit'], account?.permissions),
            },
            {
                label: 'Cancel Schedule',
                icon: <FaTimesCircle className='mr-2 text-danger'/>,
                command: () => {
                    handleStatus(5)//Arrived
                },
                visible: scheduleDetails.status_id == 1 || scheduleDetails.status_id == 2 ? true : false,
                disabled: !helpers.checkPermissions(['superAdmin', 'voyageScheduleEdit'], account?.permissions),
            },
    ];

    async function handleStatus(status = '') {
        let status_name = 'Scheduled';
        let title = 'Confirmation';
        let confirmButtonColor = '#6c757d'; // Default gray

        // Match your status IDs with human readable words and color accents
        if (status == 3) {
            status_name = 'Sailed';
            title = 'Departure Confirmation';
            confirmButtonColor = '#0d6efd'; // Primary Theme Blue
        } else if (status == 4) {
            status_name = 'Arrived';
            title = 'Arrival Confirmation';
            confirmButtonColor = '#198754'; // Success Theme Green
        } else if (status == 5) {
            status_name = 'Cancelled';
            title = 'Cancel Confirmation';
            confirmButtonColor = '#dc3545'; // Success Theme Green
        }

        // 1. Await the SweetAlert modal confirmation response cleanly
        const result = await Swal.fire({
            title: title,
            text: `Are you sure you want to mark this schedule as ${status_name}?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Yes, proceed',
            cancelButtonText: 'Cancel',
            confirmButtonColor: confirmButtonColor,
        });

        // 2. Handle action if confirmed
        if (result.isConfirmed) {
            try {
                setLoading(1); // Set loading state to true before starting API call

                let endpoint = helpers.createShipBookingHubUrl(`voyage/${schedule_id}/change-status`);
                const form_data = { "status": status };
                
                // Now await works perfectly because it's at the top level of the async function
                const res = await postApiData(endpoint, form_data, false);

                if (res.status === 'error') {
                    toast.current.show({ severity: 'error', detail: res.message, life: 10000 });
                } else {
                    toast.current.show({ severity: 'success', detail: res.message, life: 20000 });
                    fetchData(); // Refresh table datasets
                }
            } catch (error) {
                toast.current.show({ severity: 'error', detail: 'An unexpected connection error occurred.', life: 10000 });
            } finally {
                setLoading(0); // Safely clear loading screen state
            }
        }
    }

    useEffect(() => {
        initTreeView()
        
        if(schedule_id){
            fetchData(schedule_id)
        }
    }, []);

    useEffect(() => {
        const handleResize = () => {
        // 768px is the standard mobile breakpoint (md)
        if (window.innerWidth < 768) {
            setAlignment('left');  // Snaps left edge of menu to left edge of button
        } else {
            setAlignment('right'); // Snaps right edge of menu to right edge of button
        }
        };

        // Run once on load
        handleResize();

        // Listen for screen adjustments
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);
    
    useEffect(() => {
        displayDataTable(manifestData)
    }, [
        selected_items, 
        selected_all
    ]);
    
    function fetchData(){
        const url = helpers.createShipBookingHubUrl(`voyage/${schedule_id}`)

        setLoading(1)
        httpRequest(url, "GET", {}, true)
        .then((res) => {
            setScheduleDetails(res)
            fetchManifest()
        })
        .catch((err) => {
            setLoading(0)
            toast.current.show({
                severity: 'error', 
                summary: 'Notice', 
                detail: err.message, 
                life: 5000 
            });
        }); 

    }

    async function fetchManifest(){
        const page = datatable_state.page
        const per_page = datatable_state.rows
        const search = search_key
        let filter = `?paginate=1&`

        if(page){
            filter += 'page='+page+'&'
        }
        if(per_page){
            filter += 'per_page='+per_page+'&'
        }
        if(search){
            filter += 'search='+search+'&'
        }

        filter = filter.slice(0, -1)

        setLoading(1)

        const endpoint = helpers.createShipBookingHubUrl(`voyage/${schedule_id}/manifest${filter}`)

        const res = await getApiData(endpoint, false)

        if(res){
            setLoading(0)
            setManifestData(res)
            displayDataTable(res)
        }
                
        if(res.status === 'error'){
            setLoading(0)
            toast.current.show({
                severity: 'error', 
                summary: 'Notice', 
                detail: res.message, 
                life: 5000 
            });
        }
    }

    // Formatter for the center display (e.g., 27 Apr 2026)
    const formatDisplayDate = (date) => {
        if (!date) return '';

        // Convert string to Date object if it isn't one already
        const d = typeof date === 'string' ? new Date(date) : date;

        // Check if the date is actually valid to avoid "Invalid Date" strings
        if (isNaN(d.getTime())) return '';

        return d.toLocaleDateString('en-GB', {
            day: '2-digit',
            month: 'short',
            year: 'numeric'
        });
    };

    const formatTravelDate = (date, type = 'full') => {
        if (!date) return '';

        const days = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

        const d = new Date(date);
        const dayName = days[d.getDay()];
        const monthName = months[d.getMonth()];
        const year = d.getFullYear();
        const dateNum = String(d.getDate()).padStart(2, '0');
        const monthNum = String(d.getMonth() + 1).padStart(2, '0');

        if (type === 'short') {
            // Returns: 04 / 27 / 2026
            return `${monthNum} / ${dateNum} / ${year}`;
        }

        // Returns: 2026 Apr 27 (MON)
        return `${year} ${monthName} ${dateNum} (${dayName})`;
    };

    function displayStatusBadge(status_id = '', status_name = ''){
        let label = '';
        let class_name = ''

        switch (Number(status_id)) {
            case 1://Pending
                class_name = "bg-success"
                break;
            default:
                class_name = "text-light bg-warning"
        }

        if(class_name){
            // label = <span className={`text-center rounded p-2 text-white text-sm ${class_name}`}>{status_name}</span>
            label = <span className={`text-center rounded px-2 py-1 text-white text-sm ${class_name} ml-2`}>{status_name}</span>
        }

        return label;
    }

    function displayScheduleStatusBadge(status_id = '', status_name = ''){
        let label = '';
        let class_name = ''

        switch (Number(status_id)) {
            case 1://Schedule
                class_name = "bg-purple"
                break;
            case 2://Boarding
                class_name = "bg-warning"
                break;
            case 3://Sailed
                class_name = "bg-primary"
                break;
            case 4://Arrived
                class_name = "bg-success"
                break;
            case 5://Cancelled
                class_name = "bg-danger"
                break;
            default:
                class_name = "text-light bg-secondary"
        }

        if(class_name){
            label = <span className={`text-center rounded px-2 py-1 text-white text-xs ${class_name} ml-2`}>{status_name}</span>
        }

        return label;
    }

    function displayDataTable(data){
        setDataTable(
            <DataTable 
                className='border-top'
                dataKey={data.id}
                value={data.data} 
                // tableStyle={{ minWidth: '50rem' }}
                size="small"
                paginator 
                rows={data.per_page} 
                rowsPerPageOptions={[5, 10, 20, 25, 50]}
                totalRecords={data.total}
                onPage={onPage}
                first={datatable_state.first}
                lazy
                currentPageReportTemplate="{first} to {last} of {totalRecords}"
                selection={selected_items} 
                onSelectionChange={onSelectItem}
                scrollHeight="500px"
                scrollable
                responsive={true}
                emptyMessage="No data to display"
            >
                <Column selectionMode="multiple" headerStyle={{ width: '3rem' }} />
                <Column field="booking_ref" header="Booking Ref" />
                <Column field="plate_number" header="Plate Number" />
                <Column 
                    body={({brand, model_name})=> `${brand} | ${model_name}`} 
                    header="Vehicle Details" 
                />
                <Column field="customer_name" header="Owner/Consignee" />
                <Column 
                    header="Status" 
                    body={({is_onboarded})=> displayStatusBadge(is_onboarded, is_onboarded ? 'Boarded' : 'Pending Boarding')}
                />
                <Column className="text-right" body={displayActionMenu} style={{ maxWidth: '50px' }}></Column> 
            </DataTable>
        )

    }

    const onPage = (e) => {
        setDataTableState(e)
        //setSelectedItems([])
    };

    const onSelectItem = (e) => {
        const value = e.value;
        setSelectedItems(value);
    };

    function displayActionMenu(rowData, options){
        return (
            <button 
                className="btn btn-outline-secondary" 
                onClick={(event) => {
                // 1. Capture the specific row data first
                setSelectedRowData(rowData);
                
                // 2. Toggle the shared single menu component relative to this clicked button
                menuRef.current.toggle(event);
                }} 
                aria-haspopup
                aria-controls="table_action_menu"
            >
                {/* fa fa-ellipsis-v */}
                <FaEllipsisV className='mb-1' />
            </button>
        );
    }

    
    function editForm(id){
        //setShowModal(1)
        //setShipID(id)
    }
    
    
    function search(e){
        let { value } = e.target;
        setSearchKey(value)
        fetchManifest()
    }
    
    function triggerAction(data = '', action = '', status = ''){
        let ids = [];
        if(action === 'single-delete'){
            ids.push(data.id)
        }
        else{
            ids = data.map(o => o['id']);
        }

        let title = 'Delete Ship'
        if(ids.length > 1){
            title = 'Delete Categories'
        }

        Swal.fire({
            title: title,
            text: 'This action cannot be reversed. All associated records will also be deleted. Do you want to continue?',
            showCancelButton: true,
            showConfirmButton: false,
            closeOnCancel: true,
            showDenyButton: true,
            denyButtonText: 'Yes'
        })
        .then((result) => {
            if (result.isDenied) {
                //deleteItem(ids)
            }
        })
    }
    
    function handleScanQR(e){
        setShowScanner(1)
    }

    function handleProceed(e){
        setShowPreview(0)
        setBookingItemID('')
        proceedOnboard(e.id, schedule_id)
    }

    function proceedOnboard(id, sched_id){
        setLoading(1)

        const url = helpers.createShipBookingHubUrl('onboard')
        httpRequest(url, 'POST', {
            postdata: {
                "id": id,
                "schedule_id": sched_id
            },
        }, true)
        .then((res) => {
            setLoading(0)
            
            toast.current.show({
                severity: 'success', 
                summary: 'Success', 
                detail: res.message, 
                life: 10000 
            });
            fetchData()
        })
        .catch((err) => {
            console.log(err)
            setLoading(0)
            toast.current.show({
                severity: 'error', 
                summary: 'Notice', 
                detail: err.message, 
                life: 10000 
            });
        }); 

    }

    function handleSave(){
        fetchData()
    }

    function handleQR(e){
        let qr_value = e
        setBookingItemID(qr_value)
        setShowPreview(1)
        //fetchData(qr_value)
    }

    return (
        <>
        <Toast ref={toast} position="top-right" />
                
        <SchedulesForm 
            is_show={show_schedule} 
            setShow={setShowSchedule} 
            handleSave={handleSave} 
            reference_id={schedule_id}
        />
                
        <QRScannerModal 
            is_show={show_scanner}
            setShow={setShowScanner}
            handleResult={handleQR}
        />

        <BoardingPreview 
            is_show={show_preview} 
            setShow={setShowPreview} 
            handleSave={handleProceed} 
            reference_id={booking_item_id}
        />

        <Layout page_title={page_title} menu={menu} parent_text="Manage Schedules" parent_link='/ship-booking/bookings' breadcrumbs={true}>
            <div className="container-fluid" style={{position: 'relative'}}>
                <Loader isLoading={loading}/>
                <div className="containers">
                    <div className='border bg-white rounded shadow-sm p-4 mb-3 d-flex flex-column flex-md-row justify-content-between align-items-centers'>
                            <div>
                                <h5 className='mb-2 font-weight-bold d-flex'>
                                    {scheduleDetails.ship_name}
                                    {displayScheduleStatusBadge(scheduleDetails.status_id, scheduleDetails.status_name)}
                                </h5>
                            
                                <div>Voyage No: {scheduleDetails.voyage_no}</div>

                                <div className='d-flex align-items-center mb-1'>
                                    <h6 className='mb-0'>{scheduleDetails.origin}</h6> 
                                    <span className='text-primary mx-2'>&rarr;</span> 
                                    <h6 className='mb-0'>{scheduleDetails.destination}</h6>
                                </div>

                                <div className="d-flex align-items-center flex-wrap text-muted small font-weight-normal">
      
                                    {/* Date Item */}
                                    <div className="d-flex align-items-center mr-2">
                                        <i className="far fa-calendar-alt mr-2"></i>
                                        <span>{formatTravelDate(scheduleDetails.start)}</span>
                                    </div>

                                    {/* Separator Dot */}
                                    {/* <span className="mx-2 font-weight-bold text-secondary">•</span> */}

                                    {/* Time Item */}
                                    <div className="d-flex align-items-center">
                                        <i className="far fa-clock mr-2"></i>
                                        <span>{helpers.formatTime(scheduleDetails.start)} (Departure)</span>
                                    </div>

                                </div>
                            </div>

                            <div>
                                <Button 
                                    className='btn btn-outline-secondary mr-3'
                                    style={{ borderRadius: '8px', boxShadow: '0 2px 5px rgba(0,0,0,0.1)' }}
                                    onClick={(event) => menuRight.current.toggle(event)} 
                                    aria-controls="popup_menu_right"
                                    aria-haspopup
                                ><BsThreeDotsVertical /></Button> 
                                <Menu 
                                    model={action_items} 
                                    popup ref={menuRight} 
                                    id="popup_menu_right" 
                                    popupAlignment={alignment}
                                />

                                <Link 
                                    className='bg-whites btn btn-dark' to="/ship-booking/schedules"
                                    style={{ borderRadius: '8px', boxShadow: '0 2px 5px rgba(0,0,0,0.1)' }}
                                >Back</Link> 
                            </div>
                    </div>
                    
                    {/* <div className='trip-summary mb-5'>
                        <h5 class="font-weight-bold text-uppercase mb-3">Trip Summary</h5> 
                        
                        <div className="departure border-0 rounded bg-white shadow-sm">
                                {data_table}
                        </div>
                    </div> */}


                    <div className="card">
                        <div className="card-header border-bottom-0">
                            <div className="row">
                                <div className="col-lg-3">
                                    <InputText className="w-100" placeholder="Search" onChange={search} />
                                </div>
                                <div className="col-lg-9  d-flex align-items-center justify-content-end">
                                    <div className='d-flex justify-content-end py-2'>
                                        <button type='button' className='btn btn-primary float-rights' onClick={handleScanQR} disabled={!helpers.checkPermissions(['superAdmin', 'shipOnBoarding'], account?.permissions)}>
                                            <MdOutlineQrCodeScanner size={20} className='mr-2'/>Scan QR
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card-body p-0">
                            <Menu 
                                model={menuItems} 
                                popup 
                                ref={menuRef} 
                                id="table_action_menu"
                                popupAlignment={alignment} 
                            />
                            { data_table }
                        </div>
                    </div>

                </div>

            </div>
        </Layout>
        </>
    )
}